// TODO(#23079): In-memory mock for "relates to". Delete this folder once the GraphQL `relatedIssues` field
// + `addRelatesTo`/`removeRelatesTo` mutations land.

import type {RelatesToIssueNode} from './relates-to-types'

type Listener = () => void

const EMPTY: readonly RelatesToIssueNode[] = Object.freeze([])

const store = new Map<string, readonly RelatesToIssueNode[]>()
const listeners = new Set<Listener>()

function emit() {
  for (const listener of listeners) listener()
}

export function subscribe(listener: Listener): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export function getRelatesToSnapshot(issueId: string): readonly RelatesToIssueNode[] {
  return store.get(issueId) ?? EMPTY
}

// Stores a single directed edge (A→B). The reverse edge is intentionally omitted — real symmetry is the
// server's job in #23079, so a related issue navigated to won't show the back-link while dogfooding.
export async function addRelatesTo(issueId: string, node: RelatesToIssueNode): Promise<void> {
  const current = store.get(issueId) ?? EMPTY
  if (current.some(n => n.id === node.id)) return
  store.set(issueId, [...current, node])
  emit()
}

export async function removeRelatesTo(issueId: string, relatedIssueId: string): Promise<void> {
  const current = store.get(issueId)
  if (!current) return
  const next = current.filter(n => n.id !== relatedIssueId)
  if (next.length === current.length) return
  store.set(issueId, next)
  emit()
}

/** Test/fixture-only helpers. Live in this module only because the whole mock folder is temporary (#23079). */
export function seedRelatesTo(issueId: string, nodes: readonly RelatesToIssueNode[]) {
  // Callers must pass pre-escaped `titleHTML` (unlike `addRelatesTo`, this does not escape).
  store.set(issueId, [...nodes])
  emit()
}

export const __relatesToTestStore = {
  reset() {
    store.clear()
    emit()
  },
}
